exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2kU1kW16F6BcGBOIu8SauZ{width:16px;height:3px;position:absolute;top:23px;z-index:1}html[dir=ltr] ._2kU1kW16F6BcGBOIu8SauZ{left:9px}html[dir=rtl] ._2kU1kW16F6BcGBOIu8SauZ{right:9px}", ""]);
// Exports
exports.locals = {
	"colorHint": "_2kU1kW16F6BcGBOIu8SauZ"
};